import EditEventContainer from "../containers/EditEventContainer";

const EditEventPage = () => {
  return (
    <EditEventContainer />
  );
};

export default EditEventPage;
